// Print a report table in a new window (A4 landscape): title, filter line, totals, table.
//   printTable({ title, subtitle, company, summary: [['Opening', '12.3400'], ...],
//                columns: [{ key, label, align }], rows: [{...}], rowClass: r => 'neg' })
const esc = v => String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export function printTable({ title, subtitle = '', company = '', summary = [], columns, rows, rowClass }) {
  const w = window.open('', '_blank');
  if (!w) return false;
  const head = columns.map(c => `<th class="${c.align || ''}">${esc(c.label)}</th>`).join('');
  const body = rows.map(r => `<tr class="${rowClass ? rowClass(r) || '' : ''}">${columns.map(c => `<td class="${c.align || ''}">${esc(c.value ? c.value(r) : r[c.key])}</td>`).join('')}</tr>`).join('');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${esc(title)}</title><style>
    @page { size: A4 landscape; margin: 10mm; }
    * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    body { font-family: Arial, sans-serif; font-size: 9.5px; color: #1f2937; margin: 0; }
    h1 { font-size: 16px; margin: 0; } .co { font-size: 11px; font-weight: 700; color: #92400e; }
    .sub { color: #6b7280; margin: 2px 0 8px; }
    .sum { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
    .sum div { border: 1px solid #e5e7eb; border-radius: 6px; padding: 4px 8px; }
    .sum b { display: block; font-size: 12px; }
    table { width: 100%; border-collapse: collapse; }
    th { background: #f3f4f6; text-align: left; padding: 4px; border: 1px solid #e5e7eb; font-size: 8.5px; text-transform: uppercase; }
    td { padding: 3px 4px; border: 1px solid #e5e7eb; }
    .r { text-align: right; } .c { text-align: center; }
    tr.neg td { background: #fef2f2; color: #b91c1c; } tr.ret td { background: #f0fdf4; } tr.open td { background: #eff6ff; }
    thead { display: table-header-group; } tr { break-inside: avoid; }
  </style></head><body>
    ${company ? `<div class="co">${esc(company)}</div>` : ''}<h1>${esc(title)}</h1><div class="sub">${esc(subtitle)}</div>
    ${summary.length ? `<div class="sum">${summary.map(([k, v]) => `<div>${esc(k)}<b>${esc(v)}</b></div>`).join('')}</div>` : ''}
    <table><thead><tr>${head}</tr></thead><tbody>${body || `<tr><td colspan="${columns.length}">No rows</td></tr>`}</tbody></table>
    <script>window.onload = function () { setTimeout(function () { window.print(); }, 300); };<\/script>
  </body></html>`);
  w.document.close();
  return true;
}
